import { render, staticRenderFns } from "./privacyAgreement.vue?vue&type=template&id=3e66889e&scoped=true"
import script from "./privacyAgreement.vue?vue&type=script&lang=js"
export * from "./privacyAgreement.vue?vue&type=script&lang=js"
import style0 from "./privacyAgreement.vue?vue&type=style&index=0&id=3e66889e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e66889e",
  null
  
)

export default component.exports